<template>
  <property-list :value="propertyList" />
</template>

<script>
import { convertAddressToString } from '@/app/library/convertAddressToString';
import { getCountry } from '@/app/library/country-state-picker';
import PropertyList from '@/app/components/PropertyList';
import { isCompanyBillingContact, isLegalContact, areContactRequiredFieldsFilled } from '@/app/domain/Contact';

export default {
  name: 'CompanyPropertyList',
  components: {
    PropertyList
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    tenantContacts: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    propertyList() {
      const companyProperties = [
        {
          name: this.$t('profile.company.official-name'),
          value: this.value.officialName
        },
        {
          name: this.$t('profile.company.brand-name'),
          value: this.value.brandName
        },
        {
          name: this.$t('profile.company.registration-number'),
          value: this.value.registrationNumber
        },
        {
          name: this.$t('profile.company.size'),
          value: this.value.size
        },
        {
          name: this.$t('profile.company.website'),
          value: this.value.website,
          transform: 'link'
        },
        {
          name: this.$t('profile.company.industry'),
          value: this.value.industry
        }
      ];

      const nonEmptyContacts = this.tenantContacts.filter((contact) => areContactRequiredFieldsFilled(contact, true));
      const legalContact = nonEmptyContacts.find((contact) => isLegalContact(contact));

      if (legalContact) {
        companyProperties.push({
          name: this.$t('profile.company.legal-information'),
          value: this.createContactInfo(legalContact)
        });
      }

      const billingContact = nonEmptyContacts.find((contact) => isCompanyBillingContact(contact));

      if (billingContact) {
        companyProperties.push({
          name: this.$t('profile.company.billing-information'),
          value: this.createContactInfo(billingContact)
        });
      }

      return companyProperties;
    }
  },
  methods: {
    createContactInfo(contact) {
      return [
        `${contact.firstName} ${contact.lastName}`,
        contact.email,
        contact.phone,
        convertAddressToString({
          address: contact.address,
          city: contact.city,
          zipCode: contact.zipCode,
          state: contact.state,
          country: getCountry(contact.country)?.name
        })
      ].filter(Boolean).join('\n');
    }
  }
};
</script>
